import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "header__cart-item",
  "data-test": "cart-item"
}
const _hoisted_2 = { class: "header__cart-item-image" }
const _hoisted_3 = ["src"]
const _hoisted_4 = { "data-test": "cart-item-title" }
const _hoisted_5 = { class: "header__cart-item-qty" }
const _hoisted_6 = ["value"]
const _hoisted_7 = {
  class: "header__cart-item-price",
  "data-test": "cart-item-price"
}

import { round } from "@/composables/round";
import { useCartStore } from "../store/cart";
import { computed } from "vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'CartItem',
  props: ["id", "title", "thumbnail", "price"],
  setup(__props) {

/**
 * CartItem
 *
 * Renders a single item in the cart with its image, title,
 * price, and quantity controls (increase, decrease, remove).
 *
 * Props: id, title, thumbnail, price
 */
const cartStore = useCartStore();

const props = __props;

const cartItems = computed(() => {
  return cartStore.cartItems;
});

const itemQty = computed(() => {
  const item = cartItems.value.find((item) => item.product.id === props.id);
  return item ? item.qty : 1;
});

const roundedPrice = computed(() => {
  return round(props.price * itemQty.value);
});

function increaseCartItemQty() {
  const item = cartItems.value.find((item) => item.product.id === props.id);
  if (!item) return;
  cartStore.addToCart(item.product);
}
function decreaseCartItemQty() {
  cartStore.decreaseQuantity(props.id);
}
function removeItemFromCart() {
  cartStore.removeFromCart(props.id);
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", {
        class: "header__cart-item-remove",
        "data-test": "cart-item-remove",
        onClick: removeItemFromCart
      }, [...(_cache[0] || (_cache[0] = [
        _createElementVNode("svg", {
          width: "24",
          height: "24",
          viewBox: "0 0 24 24",
          fill: "none",
          xmlns: "http://www.w3.org/2000/svg"
        }, [
          _createElementVNode("circle", {
            cx: "12",
            cy: "12",
            r: "9",
            fill: "#DB4444"
          }),
          _createElementVNode("path", {
            d: "M9 15L12 12M15 9L11.9994 12M11.9994 12L9 9M12 12L15 15",
            stroke: "white",
            "stroke-width": "2",
            "stroke-linecap": "round",
            "stroke-linejoin": "round"
          })
        ], -1)
      ]))]),
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("img", { src: __props.thumbnail }, null, 8, _hoisted_3)
      ]),
      _createElementVNode("p", _hoisted_4, _toDisplayString(__props.title), 1),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", {
          class: "header__cart-item-increase",
          "data-test": "cart-item-increase",
          onClick: increaseCartItemQty
        }, [...(_cache[1] || (_cache[1] = [
          _createElementVNode("svg", {
            width: "16",
            height: "16",
            viewBox: "0 0 16 16",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg"
          }, [
            _createElementVNode("path", {
              d: "M7.75732 7.36663L4.45732 10.6666L3.51465 9.72396L7.75732 5.48129L12 9.72396L11.0573 10.6666L7.75732 7.36663Z",
              fill: "black"
            })
          ], -1)
        ]))]),
        _createElementVNode("input", {
          "data-test": "cart-item-qty",
          class: "header__cart-item-qty-input",
          type: "number",
          min: "1",
          value: itemQty.value
        }, null, 8, _hoisted_6),
        _createElementVNode("div", {
          class: "header__cart-item-decrease",
          "data-test": "cart-item-decrease",
          onClick: decreaseCartItemQty
        }, [...(_cache[2] || (_cache[2] = [
          _createElementVNode("svg", {
            width: "16",
            height: "16",
            viewBox: "0 0 16 16",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg"
          }, [
            _createElementVNode("path", {
              d: "M8.24268 8.63337L11.5427 5.33337L12.4854 6.27604L8.24268 10.5187L4.00002 6.27604L4.94268 5.33337L8.24268 8.63337Z",
              fill: "black"
            })
          ], -1)
        ]))])
      ]),
      _createElementVNode("p", _hoisted_7, " $" + _toDisplayString(roundedPrice.value), 1)
    ])
  ]))
}
}

})